"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OutPlacementAdapter = (function () {
    function OutPlacementAdapter(input) {
        this.conditions = input.conditions;
        this.frequency = input.frequency;
        this.medium = input.medium;
        this.frequencyCapping = input.frequencyCapping;
        this.pi = input.pi;
        this.share = input.share;
        this.targeting = input.targeting;
        this.additionalData = input.additionalData;
        this.userAnnotation = input.userAnnotation;
        this.group = input.group;
        this.specialDiscounts = input.specialDiscounts;
        this.setDateStringFromPeriod(input.period);
        delete this.medium["shortTitle"];
        delete this.medium["title"];
        if (_.get(this.period, "content.ownTitle")) {
            delete this.period.content.ownTitle;
        }
        delete this.medium["period"];
        this.tag = input.tag;
    }
    OutPlacementAdapter.prototype.setDateStringFromPeriod = function (period) {
        var _this = this;
        this.period = period;
        var padLeadingZero = function (inDate) {
            var threshold = 10;
            return inDate < threshold ? "0" + inDate : inDate.toString();
        };
        this.period.content.ranges.forEach(function (rangeArray, rangeArrayIndex) {
            rangeArray.forEach(function (range, rangeIndex) {
                if (_.isDate(range)) {
                    _this.period.content.ranges[rangeArrayIndex][rangeIndex] =
                        range.getFullYear() + "-" + padLeadingZero(range.getMonth() + 1) + "-" + padLeadingZero(range.getDate());
                }
            });
        });
    };
    return OutPlacementAdapter;
}());
exports.OutPlacementAdapter = OutPlacementAdapter;
//# sourceMappingURL=OutPlacementAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/OutPlacementAdapter.js
// module id = 72
// module chunks = 0